module.exports = __webpack_public_path__ + "static/process-821cc16efdb7aceb73803553fc1c8eb3.png";